import Swiper, {
	Navigation,
	Pagination,
	Autoplay,
	Scrollbar,
	EffectFade
} from 'swiper';
import { customHeaderAnimation } from './slideshow/effect-custom-header'

Swiper.use([Navigation, Autoplay, Pagination, Scrollbar, EffectFade, customHeaderAnimation]);

window.addEventListener('load', () => {
	const featuredSlideshow = document.querySelector('.o-header--featured .slideshow .swiper-container')
	if(featuredSlideshow) {
		new Swiper(featuredSlideshow, {
			slidesPerView: '1',
			effect: 'fade',
			loop: true,
			allowTouchMove: false,
			noSwiping: false,
			// autoHeight: true,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
				renderBullet: function (index, className) {
					return '<span class="' + className + '">' + this.slides[index + 1].getAttribute('data-slide') + '</span>';
				}
			},
			customHeaderAnimation: true
			// breakpoints: {
			// 	767: {
			// 		autoHeight: false
			// 	}
			// }
		});
	}

	const carouselFade = document.querySelector('.o-carousel--fade .swiper-container')
	if(carouselFade) {
		new Swiper(carouselFade, {
			slidesPerView: 'auto',
			effect: 'fade',
			navigation: {
				nextEl: carouselFade.querySelector('.is-next'),
				prevEl: carouselFade.querySelector('.is-previous'),
				disabledClass: 'is-disabled'
			},
			fadeEffect: {
				crossFade: true
			}
		});
	}

	const carouselPartners = document.querySelector('.o-carousel--partners .swiper-container')
	if(carouselPartners) {
		new Swiper(carouselPartners, {
			slidesPerView: 'auto',
			loop: true,
			autoplay: {
				delay: 3000
			}
		});
	}

	const carouselMedia = document.querySelector('.o-media--carousel .swiper-container')
	if(carouselMedia) {
		new Swiper(carouselMedia, {
			slidesPerView: 'auto',
			navigation: {
				nextEl: carouselMedia.querySelector('.is-next'),
				prevEl: carouselMedia.querySelector('.is-previous'),
				disabledClass: 'is-disabled'
			},
			scrollbar: {
				el: '.swiper-scrollbar',
				draggable: true
			}
			// autoplay: {
			// 	delay: 3000
			// }
		});
	}
})



// WEBPACK FOOTER //
// ./js/modules/carousel.js